import React from 'react'
import { IAttributeFieldProps } from './IAttributeField'

function AttributeFieldDate({currValue, setCurrValue}: IAttributeFieldProps) {
  return (
    <input type="date" value={currValue} onChange={(e) => setCurrValue(e.target.value)} className="form-control mb-3" />
  )
}

export default AttributeFieldDate